import type { ClientOverlap } from "@faire/web--source/common/settings/hooks/createSettingsContextProvider";
import { ISettingEntry } from "@faire/web-api--source/indigofair/settings/ISettingEntry";
import type { SettingConst } from "@faire/web-api--source/types";
import { useEffect } from "react";

import { useAssignSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";

export function useEffectAssignWhen<
  T extends keyof typeof ISettingEntry.SerializeToClient,
>(
  setting: SettingConst<
    string,
    unknown,
    ClientOverlap<"RETAILER" | "LOGGED_IN_RETAILER", T>
  >,
  assignWhen: boolean
): void {
  const assign = useAssignSetting(setting);
  useEffect(() => {
    if (assignWhen) {
      assign();
    }
  }, [assignWhen, assign]);
}
